<template>
  <section :id="id">
    <form :aria-required="required" class="FormSection" data-testid="document-form-section" @submit.prevent>
      <div class="w-full flex justify-between align-middle">
        <NovaFieldHeading
          :title="resolvedTitle"
          :description="resolvedDescription"
          :required="required"
        ></NovaFieldHeading>
        <div>
          <slot name="after-description"></slot>
        </div>
      </div>
      <div v-if="examples" class="FormSection__examples">
        <p>{{ $t("common.examples") }}:</p>
        <ul>
          <li v-for="example in examples" :key="example" data-testid="form-example">
            {{ example }}
          </li>
        </ul>
      </div>
      <div class="mt-4" :style="{ maxWidth: `${slotMaxWidth}px` || '100%' }" data-testid="form-slot-container">
        <slot />
      </div>
    </form>
  </section>
</template>

<script lang="ts" setup>
import NovaFieldHeading from "@/ui-kit/NovaFieldHeading/NovaFieldHeading.vue";

export interface Props {
  id: string;
  title?: string;
  required?: boolean;
  showDescription?: boolean;
  description?: string;
  examples?: string[];
  slotMaxWidth?: number;
}

const props = withDefaults(defineProps<Props>(), { title: undefined, showDescription: true, description: undefined });
const { $t } = useNuxtApp();

const resolvedTitle = computed(() => props.title ?? $t(`experience.${props.id}.title`));
const resolvedDescription = computed(() => {
  if (!props.showDescription) return undefined;
  if (props.description) return props.description;
  return $t(`experience.${props.id}.description`);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/utilities";

.FormSection {
  &__examples {
    margin-bottom: rem(15);
    color: var(--color-text-90);

    @include font-regular(12);
  }

  &__examples > ul {
    list-style: circle;
    padding-left: rem(20);
  }
}
</style>
